<template lang="pug">
  froala#editor(:tag="'textarea'" :config="config" @input="changeContent" v-bind:value="answer")
</template>
<script>
export default {
  props: {
    answer: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      config: {
        placeholderText: 'Nhập ...',
        key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
        htmlUntouched: true,
        heightMin: 248,
        autofocus: true,
        charCounterMax: 10,
        charCounterCount: true
      }
    }
  },
  methods: {
    changeContent($event) {
      this.$emit('pushContent', $event)
    }
  },
  created () {
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// itemFloara.vue?408e0c5f